import { useEffect } from "react";

const useSeoMetadata = ({ title, description, ogTitle }) => {
  useEffect(() => {
    const oldTitle = document.title;
    document.title = title;
    const tags = [
      [
        'meta[name="description"]',
        { name: "description", content: description },
      ],
      ['meta[property="og:title"]', { property: "og:title", content: ogTitle }],
      [
        'meta[property="og:description"]',
        { property: "og:description", content: description },
      ],
      ['meta[property="og:type"]', { property: "og:type", content: "website" }],
    ];
    const revert = tags.map(([selector, attrs]) => {
      let node = document.head.querySelector(selector);
      const created = !node;
      if (!node) {
        node = document.createElement("meta");
        document.head.appendChild(node);
      }
      const oldAttrs = Object.fromEntries(
        Object.keys(attrs).map((k) => [k, node.getAttribute(k)]),
      );
      Object.entries(attrs).forEach(([k, v]) => node.setAttribute(k, v));
      return () => {
        if (created) node.remove();
        else
          Object.entries(oldAttrs).forEach(([k, v]) =>
            v === null ? node.removeAttribute(k) : node.setAttribute(k, v),
          );
      };
    });
    return () => {
      document.title = oldTitle;
      revert.forEach((fn) => fn());
    };
  }, [title, description, ogTitle]);
};

export default useSeoMetadata;
